import {
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  LockClosedIcon,
  ShieldCheckIcon,
  TableCellsIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

export interface ExploreService {
  id?: string;
  title: string;
  subtitle: string;
  body: string;
  Icon: React.ComponentType<{ className?: string }>;
  action: string;
  href: string;
  /** When true the href is an internal react-router route, not an external URL. */
  internal?: boolean;
}

export const exploreServices: ExploreService[] = [
  {
    id: 'form-llc',
    title: 'Form your LLC',
    subtitle: 'Start your Wyoming LLC formation',
    body: 'Get set up fast with no hidden steps or surprise requirements. DAG walks you through the entire process — create your account, choose your path, submit payment, and we handle the rest.',
    Icon: ChartBarIcon,
    action: 'Get started',
    href: `${process.env.REACT_APP_LLC_URL || 'http://localhost:3000/llc'}/intake`,
  },
  {
    id: 'dag-trading',
    title: 'DAG Trading',
    subtitle: '',
    body: 'Wyoming LLCs are uniquely positioned for crypto trading. Operating through your LLC separates personal assets from trading activity and may unlock significant tax advantages. Uphold integration lets you trade directly under your entity.',
    Icon: ChartBarIcon,
    action: 'Get started',
    href: '/trading',
    internal: true,
  },
  {
    title: 'Estate Plans',
    subtitle: 'Protect what your LLC builds',
    body: 'Without an estate plan, your LLC ownership interests may pass through probate — a public, costly process. An estate plan helps your business assets transfer as you intend, on your timeline, to your chosen beneficiaries.',
    Icon: DocumentTextIcon,
    action: 'Learn more',
    href: '/estate-plans',
    internal: true,
  },
  {
    title: 'Trusts',
    subtitle: 'Add privacy and protection layers',
    body: 'Placing your LLC inside a trust may provide a second layer of asset protection and complete probate avoidance. Ideal for multi-entity structures or anyone prioritizing privacy — generally the trust, not you personally, appears as the owner on public records.',
    Icon: LockClosedIcon,
    action: 'Learn more',
    href: '/trusts',
    internal: true,
  },
  {
    title: 'Tax Support',
    subtitle: 'Independent crypto tax preparation that gets it right',
    body: "Swaps across chains, staking rewards, NFTs, liquidity pools — most local CPAs don't know how to report any of it. DAG connects you with independent tax professionals who prepare and file returns for people with crypto holdings alongside traditional investments.",
    Icon: TableCellsIcon,
    action: 'Learn more',
    href: '/tax-support',
    internal: true,
  },
  {
    title: 'Consultations',
    subtitle: 'One-on-one with our specialists',
    body: "Before forming, restructuring, or adding services to your LLC, a one-on-one session with our team ensures your setup aligns with your goals — whether that's asset protection, tax efficiency, or estate planning.",
    Icon: ChatBubbleLeftRightIcon,
    action: 'Learn more',
    href: '/consultations',
    internal: true,
  },
  {
    title: 'Insurance',
    subtitle: 'Protect what matters most',
    body: 'Life, health, auto, and home coverage tailored to your needs. Our specialists help you find the right policy to safeguard your assets and your family — whether you need personal coverage or protection for your LLC.',
    Icon: ShieldCheckIcon,
    action: 'Get a quote',
    href: '/insurance',
    internal: true,
  },
];
